export default "__VITE_ASSET__CZ$4nyCm__"